// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "da71ecec63e3";
export const BUILD_VERSION_NUMBER = 38;
